import { render, staticRenderFns } from "./processtype-tracks.vue?vue&type=template&id=22ad0532&"
import script from "./processtype-tracks.vue?vue&type=script&lang=js&"
export * from "./processtype-tracks.vue?vue&type=script&lang=js&"
import style0 from "./processtype-tracks.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports